import { useState } from "react";
import axios from "axios";
import image2 from "../components/asstes/Screenshot 2025-02-06 170310.png";

const ContactSection = () => {
          const phoneNumber = "919934822681"; 
  const message = "Hello, I want to connect with you."; 

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // New tab में खुलेगा
  };
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      email: "",
      message: "",
    });
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.id]: e.target.value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const res = await axios.post(
          "https://manirajbuilder.com/contact.php",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        alert(res.data.message || "Message sent successfully!");
        setFormData({ name: "", phone: "", email: "", message: "" }); // Reset form
      } catch (err) {
        console.error(err);
        alert("Something went wrong. Please try again later.");
      }
    };
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px",
        backgroundColor: "#f5f5f5",
        flexWrap: "wrap",
        gap: "40px",
      }}
    >
      {/* Left Section - Image & Text */}
      <div
        style={{
          flex: "1.5", // Increased width
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            color: "rgba(35, 120, 97, 1)",
            marginBottom: "20px",
          }}
        >
          Let's Find You Together The Place You Deserve
        </h2>

        {/* Image */}
        <div style={{ position: "relative", display: "inline-block", width: "100%", maxWidth: "500px" }}>
          <img
            src={image2}
            alt="Property"
            style={{
              width: "100%",
              height: "400px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          />
          {/* Ongoing Project Banner */}
          <button
          onClick={handleClick}
            style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              backgroundColor: "rgba(35, 165, 97, 1)", // Theme color
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
              padding: "12px 0",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            Ongoing Project
          </button>
        </div>
      </div>

      {/* Right Section - Contact Form */}
      <div
        style={{
          flex: "1", // Reduced width
          maxWidth: "400px", // Reduce form width
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            marginBottom: "20px",
            color: "rgba(35, 120, 97, 1)",
            fontSize: "2rem",
            fontWeight: "600",
          }}
        >
          Send Us a Message
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Name</label>
            <input
              id="name"
                type="text"
              placeholder="Enter your name"
                 value={formData.name}
                onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Email</label>
            <input
              type="email"
               id="email"
               
              placeholder="Enter your email"
               value={formData.email}
                onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>
          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Phone</label>
            <input
              type="phone"
              id="phone"
               
              placeholder="Enter your phone"
                    value={formData.phone}
                onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Message</label>
            <textarea
              placeholder="Type your message"
                     id="message"
               value={formData.message}
                onChange={handleChange}
              rows="5"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                resize: "none",
              }}
            ></textarea>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px 15px",
              backgroundColor: "rgba(35, 165, 97, 1)",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "background 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(30, 140, 85, 1)")} // Darker hover effect
            onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(35, 165, 97, 1)")}
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactSection;
